import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import MainApp from "./MainApp";
import theme from "./theme";
import { Provider } from "react-redux";

import { store } from "./app/store";
import AppUpdate from "./AppUpdate";
import ErrorBoundary from "./components/common/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root")); // Create root
root.render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <StyledEngineProvider injectFirst>
      <ErrorBoundary>
        <Provider store={store}>
          <AppUpdate>
            <MainApp />
          </AppUpdate>
        </Provider>
      </ErrorBoundary>
    </StyledEngineProvider>
  </ThemeProvider>
  // </React.StrictMode>
);
